import { render } from "./propertycoloreditor.vue?vue&type=template&id=3738638a"
import script from "./propertycoloreditor.vue?vue&type=script&lang=js"
export * from "./propertycoloreditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/propertycoloreditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3738638a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3738638a', __exports__)) {
    api.reload('3738638a', __exports__)
  }
  
  module.hot.accept("./propertycoloreditor.vue?vue&type=template&id=3738638a", () => {
    api.rerender('3738638a', render)
  })

}


export default __exports__